import React from "react";

import {CircularProgress} from "@mui/joy";

// components
import MaterialTab from "./MaterialTab";
import MaterialHeader from "./MaterialHeader";
import CommonDetail from "../Common/CommonDetail";
import withRouter from "../../utils/withRouter";
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import AccountTreeIcon from "@mui/icons-material/AccountTree";


class MaterialDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            material: null,
        };
    }

    async componentDidMount() {
        await this.retrieveMaterial();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveMaterial();
        }
    }

    async retrieveMaterial() {
        this.setState(
            {
                material: null
            }
        );
        const url = `material/${this.props.params.materialId}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                material: response.data
            }
        );
    }

    render() {
        if (!this.state.material) {
            return (<CircularProgress/>)
        }
        return (
            <CommonDetail
                appName={'Material'}
                appId={this.state.material.id}
                header={{
                    component: MaterialHeader,
                    componentProps: {
                        material: this.state.material
                    },
                    leftOverflow: {
                        icon: null,
                        title: 'Материал',
                        color: 'primary'
                    },
                }}
                defaultTabValue={'info'}
                tabComponents={[
                    {
                        title: 'Информация',
                        value: 'info',
                        icon: AccountTreeIcon,
                        component: <MaterialTab
                            material={this.state.material}
                            callBack={this.retrieveMaterial.bind(this)}
                        />,
                    },

                ]}
            />
        )
    }
}

export default withRouter(MaterialDetail);
